__turbopack_context__.v({
  "background": "Modal-module__Xk1cAG__background",
  "close": "Modal-module__Xk1cAG__close",
  "closeButton": "Modal-module__Xk1cAG__closeButton",
  "content": "Modal-module__Xk1cAG__content",
  "footer": "Modal-module__Xk1cAG__footer",
  "header": "Modal-module__Xk1cAG__header",
  "large": "Modal-module__Xk1cAG__large",
  "medium": "Modal-module__Xk1cAG__medium",
  "modal": "Modal-module__Xk1cAG__modal",
  "overlay": "Modal-module__Xk1cAG__overlay",
  "slide-in-left": "Modal-module__Xk1cAG__slide-in-left",
  "small": "Modal-module__Xk1cAG__small",
  "title": "Modal-module__Xk1cAG__title",
  "zoom-in": "Modal-module__Xk1cAG__zoom-in",
});
